
export const SET_INFNUM = 'SET_INFNUM';


export const setInformationNumber = (num) => ({
    type: SET_INFNUM,
    payload: num,
});



// WEBPACK FOOTER //
// ./src/redux/actions/informationNumber.js